export default class Render {
    constructor(Component) { this.Component = Component }

    /* Constants */
    get collection()    { return this.Component.Interface.collection }
    get container()     { return this.Component.container.querySelector('[data-container="product"]') }

    group(key = 'product') {
        let group = '';
        for (let k in this.collection[key]['items']) {
            let item = this.collection[key]['items'][k];
            if (item.template && typeof item.template !== 'string') {
                const index = this.Component.isShop ? 'shop' : 'overview';
                group += item.template[index] ? item.template[index] : this.template(item);
            } else {
                group += this.template(item);
            }
        }
        return group === '' ? this.empty() : group;
    }

    box(item) {
        return App.Template.parse('overview-box', {
            type:           item.type,
            'layout':       item.type === 'page' ? 'small' : 'normal',
            'id':           item.id,
            'title':        item.title,
            'url':          this.Component.isShop ? item.url : this.Component.url(item),
            'target':       this.Component.target(item),
            'likes':        item.likes            || 0,
            'buttons':      item.buttons          || '',
            'image':        window.devicePixelRatio > 1 ? item.image.overview : (item.image.overview || item.image.thumbnail || item.image),
            'identifier':   [item.type, item.id].join('-'),
            'subtitle':     this.Component.Interface.mode === 'subscription' ? item.subtitle : '',
            'badgeId':      item.type === 'product' ? App.Endpoint.Products.getById(item.id).badgeId : '',
            quickBuy:       false,
            class:          '',
            article:        '',
        });
    }

    template(item) {
        // Set parameters to render
        if (!item.template || typeof item.template === 'string') {
            item.template = {};
        }
        item.buttons = this.buttons(item);
        item.template[this.Component.isShop ? 'shop' : 'overview'] = this.box(item);
        return item.template[this.Component.isShop ? 'shop' : 'overview'];
    }

    buttons(item) {
        let buttons = [];
        switch (item.type) {
            case 'page':
                break;
            case 'category':
                buttons.push('information');
                break;
            case 'product':
                // Only allow price or cart button if is not ISet
                if (App.Endpoint.Products.getById(item.id).type !== 40)
                    buttons.push(this.Component.isShop ? 'price': 'cart');
                buttons.push('bar-favorite');
                break;
        }
        return buttons.join();
    }

    empty() {
        return App.Template.parse('overview-no-result');
    }

    update() {
        // We only render products now
        this.container.innerHTML = this.group();
    }
}
